import { useView, PLATFORM } from 'aurelia-framework';

export interface IGridColumnsDialogColumn {
  colId: string;
  header: string;
  visible: boolean;
  reordered?: boolean;
}

export interface IGridColumnsDialogModel {
  columns: IGridColumnsDialogColumn[];
}

@useView(PLATFORM.moduleName('elements/dialogs/grid-columns-dialog/grid-columns-dialog.html'))
export class GridColumnsDialog {
  model: IGridColumnsDialogModel;

  activate(model: IGridColumnsDialogModel) {
    this.model = model;
  }

  itemReordered(_items: IGridColumnsDialogColumn[], change: { item: IGridColumnsDialogColumn }) {
    change.item.reordered = true;
  }
}
